import DomainPage from "@/pages/solutions/DomainPage";

const config = {
  slug: "health-care",
  name: "Health-Care Systems",
  ctaName: "health-care systems",
  h1: "ER visits are an upstream-failure signal. Where is upstream failing?",
  lede:
    "Primary-care access, ER utilisation, and service capacity, mapped against population change — so a health authority can see where the primary-care system is failing before the emergency department absorbs the cost.",
  problem: [
    "Where does a community lack primary-care access, and does its ER utilisation prove it? Health authorities and PCNs can usually see one half of that picture at a time — utilisation data or access data — rarely both, place-matched, and refreshed.",
    "Continuum joins primary-care access and ER utilisation to the same geocoded evidence base already carrying housing and, soon, mental-health indicators — so capacity planning and upstream-failure signals sit on one map. This is the broadest system and the furthest from where Continuum is live today, which is why it's sequenced last — but rural councils fighting to keep a doctor, an ER, or an obstetrics unit don't need to wait for a provincial data-sharing agreement to get place-based evidence.",
  ],
  evidenceBase: {
    heading: "The fourth domain,",
    headingAccent: "not a fourth platform.",
    body:
      "By the time this domain ships, the evidence base will already carry housing, mental-health, and aging indicators for most tenant communities. Health-care systems adds primary-care and ER data to the same map — the marginal cost of a fourth domain is indicators, not infrastructure.",
  },
  produces: [
    "Primary-care access profile, by community",
    "ER utilisation dashboard, read as upstream failure",
    "Capacity-vs-population-change modelling",
  ],
  pricingNote:
    "The full module catalog publishes as data sources are confirmed — the honesty architecture applies to the roadmap too.",
  pricingRows: [
    {
      product: "Primary Care Access Profile",
      status: "PLANNED",
      who: "Health authorities, PCNs, municipalities",
      model: "Setup + annual refresh",
      price: "$8k–15k + $4k/yr",
    },
  ],
  faq: [
    {
      q: "When does this domain launch?",
      a: "No fixed date yet. Waitlist members get module releases, methodology drops, and pricing decisions as they're made — before general announcement.",
    },
    {
      q: "Do we need the housing module first?",
      a: "No. This domain will run standalone. Tenants already on housing get the shared evidence base included, since the population and geography overlap.",
    },
  ],
};

export default function HealthCareDomain() {
  return <DomainPage config={config} />;
}
